import React from 'react';

import type {
  MarketTemplateComponent,
  SingleMarketTemplateProps
} from '@swf/sports/types/templates';

import List from '../List/List';

const OddsBoost: MarketTemplateComponent<SingleMarketTemplateProps> = (props) => (
  <List {...props} showPreviousPrice />
);

OddsBoost.marketTemplateType = 'BASE';

export default OddsBoost;
